export default __webpack_public_path__ + "static/B0232-9d2ea9cd031bcb3b7996dd9bb6bbe43f.png";